module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Maps"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Master Maps")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Abbreviations"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Second Battle of Bapaume (Master Maps 3 & 4)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec1"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("402.")]), _vm._v("Lt Cecil Sewell, Royal West Kent att’d 3 (Light) Tank Bn, 29 August 1918, Frémicourt, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec2"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("403.")]), _vm._v("Pte George Cartwright, 33 Battalion, AIF, 31 August 1918, Bouchavesnes, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec3"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("405.")]), _vm._v("Pte William Currey, 53 Battalion, AIF, 1 September 1918, Péronne, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec4"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("406.")]), _vm._v("Cpl Arthur Hall, 54 Battalion, AIF, 1 September 1918, Péronne, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec5"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("407.")]), _vm._v("Cpl Alexander Buckley, 54 Battalion, AIF, 1–2 September 1918, Péronne, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec6"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("408.")]), _vm._v("Pte Robert MacTier, 23 Battalion, AIF, 1 September 1918, Mont St-Quentin, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec7"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("409.")]), _vm._v("Sgt Albert Lowerson, 21 Battalion, AIF, 1 September 1918, Mont St-Quentin, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec8"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("410.")]), _vm._v("Lt Edgar Towner, 2 Australian Machine Gun Battalion, AIF, 1 September 1918, Mont St-Quentin, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec9"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("411.")]), _vm._v("Sgt John Grant, 1 Wellington, NZEF, 1 September 1918, Bancourt, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec10"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("412.")]), _vm._v("Cpl Lawrence Weathers, 43 Battalion, AIF, 2 September 1918, Péronne, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#sec11"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("413.")]), _vm._v("Pte Jack Harvey, 1/22 London (The Queen’s), 2 September 1918, North of Péronne, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Local Operations (Master Maps 1 & 2)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("424.")]), _vm._v("Cpl John McNamara, 9 East Surrey, 3 September 1918, Lens, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("427.")]), _vm._v("LCpl Alfred Wilcox, 2/4 Ox & Bucks Light Infantry, 12 September 1918, Laventie, France")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Biographies",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Biographies")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sources")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Useful",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Useful Information")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0